export const MuiDateCalendar = () => ({
    styleOverrides: {
        root: { "& .MuiPickersCalendarHeader-labelContainer": { display: "flex" } },
    },
});
